// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2R95l","button__delete":"Button_button__delete__2Ga9w","button__icon":"Button_button__icon__1DrVD"};